'use strict';

define('checkbox', [], function (){
    const checkbox = {};
    let watchers = [];
    let onceWatchers = [];
    checkbox.$el = null;
    checkbox.init = function (parentEl) {
        watchers = [];
        onceWatchers = [];
        checkbox.$parentEl = (
            () => {
                if (parentEl instanceof jQuery) {
                    return parentEl;
                }
                if (parentEl instanceof HTMLElement) {
                    return $(parentEl);
                }
                return $(document);
            }
        )();

        checkbox.$el = parentEl.find('[checkbox]');
        checkbox.setVal = (bool) => {
            checkbox.$el.attr('input-checked', bool);
            watchers.forEach(watcher => {
                watcher.call(checkbox.$el, bool);
            });
            while (onceWatchers.length) {
                onceWatchers.shift().call(checkbox.$el, bool);
            }
            return checkbox;
        };
        checkbox.$el.find('[checkicon]').on('click', onCheck);
        initCheckIcon();
        return this;

        function onCheck() {
            const newV = !checkbox.val();
            checkbox.setVal(newV);
            return newV;
        }

        function initCheckIcon() {
            const checkicon = checkbox.$el.find('[checkicon]');
            const show = () => checkicon.addClass('icon-check'), hide = () => checkicon.removeClass('icon-check');
            // 注册watcher
            checkbox.watch((n)=>{
                n ? show() : hide();
            });
            if (checkbox.val()) {
                show();
                return;
            }
            hide();
            return checkicon;
        }
    };

    checkbox.watch = (watcher, once) => {
        (once ? onceWatchers : watchers).push(watcher);
        return checkbox;
    };

    checkbox.val = () => checkbox.$el.attr('input-checked') === "true" ? true : false;

    return checkbox;
});
